import { ValidationRule } from "../types/types.validation";

const VALIDATION_MAP: Record<string, string> = {
    'required': 'is_required',
    'date': 'is_date',
    'int': 'is_int',
    'integer': 'is_int',
    'double': 'is_double',
    'float': 'is_double',
    'numeric': 'is_double',
    'max': 'max_length',
    'min': 'min_length',
    'maxLength': 'max_length',
    'minLength': 'min_length',
    'max_length': 'max_length',
    'min_length': 'min_length',
};

function parseLegacyValidationString(str: string): ValidationRule[] {
    return str
        .split(",")
        .map(v => v.trim())
        .filter(Boolean)
        .map(part => {
            if (part.includes("=")) {
                const [type, rawParam] = part.split("=").map(v => v.trim());
                const mappedType = VALIDATION_MAP[type] || type;
                const param = isNaN(Number(rawParam)) ? rawParam : Number(rawParam);

                return {
                    type: mappedType as ValidationRule["type"],
                    params: param
                };
            }

            const mappedType = VALIDATION_MAP[part] || part;
            return {
                type: mappedType as ValidationRule["type"]
            };
        });
}

function parsePipeValidationString(str: string): ValidationRule[] {
    return str
        .split("|")
        .map(v => v.trim())
        .filter(Boolean)
        .map(part => {
            if (part.includes(":")) {
                const [type, rawParam] = part.split(":").map(v => v.trim());
                const mappedType = VALIDATION_MAP[type] || type;
                const param = isNaN(Number(rawParam)) ? rawParam : Number(rawParam);

                return {
                    type: mappedType as ValidationRule["type"],
                    params: param
                };
            }

            const mappedType = VALIDATION_MAP[part] || part;
            return {
                type: mappedType as ValidationRule["type"]
            };
        });
}

export function parseValidationRules(raw: any): ValidationRule[] | undefined {
    if (!raw) return undefined;

    if (typeof raw === "string" && raw.trim().startsWith("[")) {
        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [parsed];
        } catch {
            //
        }
    }

    if (typeof raw === "string") {
        const trimmed = raw.trim();
        
        if (trimmed.includes("|")) {
            return parsePipeValidationString(trimmed);
        }
        
        return parseLegacyValidationString(trimmed);
    }

    if (Array.isArray(raw)) {
        return raw;
    }

    if (typeof raw === "object") {
        return [raw];
    }

    return undefined;
}